import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import SessionExpiredWrapper from "./Component/SessionExpiredWrapper";
import GlobalNotificationListener from "./Component/globalNotificationListener";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <AppRoutes />

      <SessionExpiredWrapper />
      <GlobalNotificationListener />
      <ToastContainer position="top-right" autoClose={5000} />
    </Router>
  );
}

export default App;